/**
 * Move elements in the array with satisfies the predicateFn to the beginning of the array
 * @param {array} array
 * @param {function} predicateFn
 */
const moveToStart = (array, predicateFn) =>
  array.sort((a, b) => {
    if (predicateFn(a)) return -1;

    if (predicateFn(b)) return 1;

    return 0;
  });

export default moveToStart;
